import React from 'react';
import { PostComposer } from './PostComposer';
import { LivePostDisplay } from './LivePostDisplay';
import { AnalyticsDashboard } from './AnalyticsDashboard';
import { Sidebar } from './Sidebar';
export function Dashboard() {
  return <div className="flex flex-col lg:flex-row w-full min-h-screen" data-id="element-59">
      <Sidebar data-id="element-60" />
      <main className="flex-1 p-4 lg:p-6" data-id="element-61">
        <div className="max-w-6xl mx-auto space-y-6" data-id="element-62">
          <h1 className="text-2xl font-bold text-gray-800" data-id="element-63">Dashboard now</h1>
          {/* Top Section - Post Composer */}
          <section className="bg-white rounded-xl shadow-md p-6" data-id="element-64">
            <h2 className="text-lg font-semibold text-gray-700 mb-4" data-id="element-65">
              Create New Post
            </h2>
            <PostComposer data-id="element-66" />
          </section>
          {/* Middle Section - Live Post Display */}
          <section className="bg-white rounded-xl shadow-md p-6" data-id="element-67">
            <h2 className="text-lg font-semibold text-gray-700 mb-4" data-id="element-68">
              Live Posts
            </h2>
            <LivePostDisplay data-id="element-69" />
          </section>
          {/* Bottom Section - Analytics Dashboard */}
          <section className="bg-white rounded-xl shadow-md p-6" data-id="element-70">
            <h2 className="text-lg font-semibold text-gray-700 mb-4" data-id="element-71">
              Analytics Overview
            </h2>
            <AnalyticsDashboard data-id="element-72" />
          </section>
        </div>
      </main>
    </div>;
}